import React from 'react'

import classNames from 'classnames'
import { useUnit } from 'effector-react'

import { useMediaQueries } from 'hooks'

import { $zendeskArticles, $zendeskArticlesLoading } from 'app/effector/zendesk-articles'

import AllCenter from 'components/_old/AllCenter/AllCenter.jsx'
import Link from 'components/_old/Link/Link.jsx'
import { Typo } from 'components/_old/Typo'

import { Card } from 'components/atoms/Card'
import { Paper } from 'components/atoms/Paper'
import { Skeleton } from 'components/atoms/Skeleton'
import { Typography } from 'components/atoms/Typography'

import faqCover1x from '../images/faq-cover@1x.png'
import faqCover2x from '../images/faq-cover@2x.png'

import './Faq.css'

type FaqProps = {
  className: string
}

const ZendeskArticles = (): JSX.Element => {
  const zendeskArticles = useUnit($zendeskArticles)

  return (
    <React.Fragment>
      {zendeskArticles['SIPP-TRANSFERS']?.map((article) => (
        <li key={article.id}>
          <Link to={article.url} blank hard>
            <Typography tag="span" color="inherit">
              <Typo>{article.title}</Typo>
            </Typography>
          </Link>
        </li>
      ))}
    </React.Fragment>
  )
}

const Skeletons = (): JSX.Element => {
  return (
    <React.Fragment>
      {Array.from({ length: 7 }).map((_, index) => (
        <li key={index}>
          <Skeleton shown={true}>
            <Typography tag="span">
              <Typo>{'     '}</Typo>
            </Typography>
          </Skeleton>
        </li>
      ))}
    </React.Fragment>
  )
}

const Faq = ({ className }: FaqProps): JSX.Element => {
  const { desktop } = useMediaQueries()
  const zendeskArticlesLoading = useUnit($zendeskArticlesLoading)

  const content = (
    <React.Fragment>
      {desktop && (
        <AllCenter>
          <picture>
            <source srcSet={`${faqCover1x} 1x, ${faqCover2x} 2x`} type="image/png" />
            <img src={faqCover1x} width={100} height={95} />
          </picture>
        </AllCenter>
      )}

      <Typography tag="h2" weight="semibold" size={18}>
        <Typo>Frequently Asked Questions</Typo>
      </Typography>

      <Paper
        tag="ul"
        top={desktop ? 16 : 24}
        className={classNames('Faq-List', { 'Faq-List_loading': zendeskArticlesLoading })}
      >
        {zendeskArticlesLoading ? <Skeletons /> : <ZendeskArticles />}
      </Paper>
    </React.Fragment>
  )

  return desktop ? (
    <Card className={className}>
      <Paper top={24} left={24} right={24} bottom={24}>
        {content}
      </Paper>
    </Card>
  ) : (
    <div className={className}>{content}</div>
  )
}

export { Faq }
